<div class="modal-header">
  <h4 class="modal-title pull-left">Do you really want to <span style="color:red;">Delete</span> Position?</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body" *ngIf="position">
  <div class="row">

    <div class="col-sm-12 form-group">
      <label style="font-weight: normal;">
        Please enter
        <strong style="color: red;" *ngIf="position.CODE">{{position.CODE}}</strong>
        <strong style="color: red;" *ngIf="!position.CODE">{{position.ID}}</strong>
        to confirm deletion
      </label>

      <input type="text" [placeholder]="position.CODE ? position.CODE : position.ID" class="form-control" name="deleteName"
        [(ngModel)]="deleteName" />
    </div>

  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()"
    [disabled]="deleteName != position?.CODE && (deleteName != position?.ID+'')">
    Delete
  </button>
</div>
